import React from "react";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import ExchangeProfitItem from "./ExchangeProfitItem";

import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";

const ExchangeProfitList = ({ exchangesProfits, filterData, notification, setNotification, t }) => {

  if (!exchangesProfits) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  if (exchangesProfits.length === 0) {
    return <Alert severity="warning">{t("profit.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable className="profit-list-table_scroll">
      <StyledTable
        width="1768"
        size="14"
        className="profit-list-table"
      >
        <StyledTableHead scroll="auto" col="3" className="profit-list-table__head">
          <div>
            {t("profit.table.service")}
          </div>
          <div>
            {t("profit.table.currency")}
          </div>
          <div>
            {t("profit.table.profit")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {exchangesProfits && exchangesProfits.map((value, key) => (
            <ExchangeProfitItem
              key={key}
              filterData={filterData}
              value={value}
              notification={notification}
              setNotification={setNotification}
              t={t}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default ExchangeProfitList;